import type { QueryKey } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { GET_PRODUCTION_DECLARATION_KEY } from '@/keys';

export function useProductionDeclaration(
  productionDeclarationId: string,
  token: string | undefined,
) {
  const { t } = useTranslation('productionDeclaration', {
    useSuspense: false,
  });

  const queryKey: QueryKey = useMemo(
    () => [
      ...GET_PRODUCTION_DECLARATION_KEY,
      productionDeclarationId,
      token ?? '',
    ],
    [productionDeclarationId, token],
  );

  return {
    queryKey,
    loadErrorMessage: t('loadError'),
  };
}
